import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Card, Grid, TextField, Button, Typography, CircularProgress,
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login(form.email, form.password);
      navigate('/users');
    } catch (err) {
      setError(err?.response?.data?.error || err?.message || 'Login failed');
      setLoading(false);
    }
  };

  return (
    /* Dark full-screen background matching original #0e0e0e */
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#0e0e0e',
      }}
    >
      <Card
        sx={{
          maxWidth: 800,
          width: '100%',
          m: 2,
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: '0 8px 40px rgba(0,0,0,0.6)',
        }}
      >
        <Grid container>
          {/* Left panel — black with logo, matching original */}
          <Grid
            item
            lg={5} md={5} sm={5} xs={12}
            sx={{
              bgcolor: '#000',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              p: 4,
              minHeight: { xs: 180, sm: 'auto' },
            }}
          >
            <Box
              component="img"
              src="/logo512.png"
              alt="JAMSAP"
              sx={{ width: '100%', maxWidth: 220, display: 'block' }}
              /* Fallback: show text logo if image missing */
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            {/* Shown only when image fails to load */}
            <Typography
              sx={{
                display: 'none',
                color: '#fff',
                fontSize: 48,
                fontWeight: 800,
                letterSpacing: -2,
              }}
            >
              JAMSAP
            </Typography>
          </Grid>

          {/* Right panel — white with form */}
          <Grid item lg={12} md={12} sm={12} xs={12} sx={{flexGrow: 1}}> 
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{
                height: '100%',
                p: 4,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                bgcolor: 'rgba(0,0,0,0.01)',
                position: 'relative',
              }}
            >
              <TextField
                sx={{ mb: 3, width: '100%' }}
                variant="outlined"
                size="small"
                label="Email"
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                required
              />

              <TextField
                sx={{ mb: '12px', width: '100%' }}
                label="Password"
                variant="outlined"
                size="small"
                name="password"
                type="password"
                value={form.password}
                onChange={handleChange}
                required
              />

              {error && (
                <Typography sx={{ color: 'error.main', mb: 1, fontSize: 14 }}>
                  {error}
                </Typography>
              )}

              <Box sx={{ display: 'flex', alignItems: 'center', mt: 2, mb: 2 }}>
                <Box sx={{ position: 'relative' }}>
                  <Button
                    variant="contained"
                    // color="primary"
                    disabled={loading}
                    type="submit"
                  >
                    Sign in
                  </Button>
                  {loading && (
                    <CircularProgress
                      size={24}
                      sx={{ position: 'absolute', top: '6px', left: '25px' }}
                    />
                  )}
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
}
